import jquery from "jquery/dist/jquery";

globalThis.jQuery = jquery;
globalThis.$ = jquery;

jquery(document).on("ajaxError", (_event, xhr) => {
  if (xhr.getResponseHeader("X-Page-Expired")) {
    alert("La page n'est plus à jour, elle va être rechargée.");
    window.location.reload();
  }
});
